export const absoluteObject = (data: Record<string, any>) => {
  const keysList = Object.keys(data)
  return keysList.reduce((prev, curr) => {
    return data[curr] ? { ...prev, [curr]: data[curr] } : prev
  }, {})
}
